import Quill from 'quill'
import { clientePfService } from '../services/clientePf.service'
import { clientAssetsService } from '../services/client-assets.service'
import { clientAssetsService } from '../services/client-assets.service'
import { fundacaoService } from '../services/fundacao.service'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

const { showToastify } = GLOBAL

let editorEventoQuill = null
let clienteSelecionado = null

const TIPO_USUARIO = {
	CLIENTE_PF: 'PF',
	FUNDACAO: 'FUNDACAO',
}

const TIPO_STATUS_ATENDIMENTO = {
	CLIENTE_PF: 'cliente_pf',
	FUNDACAO: 'fundacao',
	SEM_ATENDIMENTO: 'sem_atendimento',
}

const EMAILS_CLIENTES_FIXOS = [
	'ri@unifinance.com.br',
	'ri@ufinvestimentos.com.br',
]

const tempoAgendamento = [
	{ label: 'Não lembrar', value: null },
	{ label: '5 minutos', value: 5 },
	{ label: '15 minutos', value: 15 },
	{ label: '30 minutos', value: 30 },
	{ label: '1 hora', value: 60 },
	{ label: '2 horas', value: 120 },
	{ label: '3 horas', value: 180 },
	{ label: '12 horas', value: 720 },
	{ label: '1 dia', value: 1440 },
	{ label: '1 semana', value: 10080 },
]

const { getClientesPf } = clientePfService()
const { getInfoAtendimentoCliente } = clientAssetsService()
const { getInformacoesFundacao } = fundacaoService()
const { formatDateObject } = GLOBAL

export default {
	name: 'ModalNovoEventoCalendario',
	props: [
		'loading',
		'eventoEdit',
		'isEditModo',
		'isDoubleClick',
		'isOpenModal',
		'isDesativado',
	],
	emits: ['click:close-modal', 'click:criar-evento', 'click:atualiza-evento'],
	data() {
		return {
			model: {
				titulo: null,
				convidados: null,
				dataEvento: null,
				horaEventoInicio: null,
				horaEventoFim: null,
				localEvento: null,
				descricaoEvento: null,
				isDiaInteiro: false,
				isTeams: false,
				isTemAtendimento: false,
				tipoClienteAtendimento: TIPO_STATUS_ATENDIMENTO.SEM_ATENDIMENTO,
				usuarioSelecionado: null,
				tipoAtendimento: null,
				dataPolitica: null,
				lembreteAtendimento: tempoAgendamento[0].value,
			},
			optionsTipoAtendimento: [
				{ label: 'Política de Atendimento', value: 0 },
				{ label: 'Outro', value: 1 },
			],
			optionsLembreteAtendimento: [...tempoAgendamento],
			optionsDataAtendimentoUsuario: [],
			optionsUsuarioSelect: [],
			qeditor: null,
			isReadOnly: false,
			labelBotaoPrincipal: 'Salvar evento',
			loadingUsuarios: false,
			loadingDataAtendimento: false,
			clientesPf: [],
			fundacoes: [],
		}
	},
	computed: {
		isRequiredInput() {
			return !this.isReadOnly
		},
		tituloModal() {
			if (this.isEditModo && this.isReadOnly) {
				return 'Evento'
			} else if (this.isEditModo && !this.isReadOnly) {
				return 'Editar evento'
			} else {
				return 'Novo evento'
			}
		},

		isDisableFieldsEditFormulario() {
			return this.isEditModo && this.isDoubleClick && this.isReadOnly
		},

		dataEventoFormatadaInfo() {
			if (!this.eventoEdit?.dataEventoInicio || !this.eventoEdit?.dataEventoFim)
				return ''

			const meses = [
				'janeiro',
				'fevereiro',
				'março',
				'abril',
				'maio',
				'junho',
				'julho',
				'agosto',
				'setembro',
				'outubro',
				'novembro',
				'dezembro',
			]

			const inicio = dayjs(this.eventoEdit.dataEventoInicio).toDate()
			const fim = dayjs(this.eventoEdit.dataEventoFim).toDate()

			if (isNaN(inicio.getTime()) || isNaN(fim.getTime())) return ''

			const dia = inicio.getDate()
			const mes = meses[inicio.getMonth()]
			const ano = inicio.getFullYear()

			const horaInicio = inicio.toLocaleTimeString('pt-BR', {
				hour: '2-digit',
				minute: '2-digit',
			})
			const horaFim = fim.toLocaleTimeString('pt-BR', {
				hour: '2-digit',
				minute: '2-digit',
			})

			if (this.eventoEdit.isDiaInteiro) {
				return `${dia} de ${mes} de ${ano} (Dia inteiro)`
			}

			return `${dia} de ${mes} de ${ano} ${horaInicio} - ${horaFim}`
		},
		lembreteFormatado() {
			const minutos = this.eventoEdit?.dataLembrete
			if (typeof minutos !== 'number' || isNaN(minutos) || minutos <= 0)
				return ''

			const SEMANA = 10080 // minutos
			const DIA = 1440
			const HORA = 60

			let resto = minutos
			const semanas = Math.floor(resto / SEMANA)
			resto = resto % SEMANA

			const dias = Math.floor(resto / DIA)
			resto = resto % DIA

			const horas = Math.floor(resto / HORA)
			const min = resto % HORA

			let partes = []
			if (semanas > 0) partes.push(`${semanas} semana${semanas > 1 ? 's' : ''}`)
			if (dias > 0) partes.push(`${dias} dia${dias > 1 ? 's' : ''}`)
			if (horas > 0) partes.push(`${horas} hora${horas > 1 ? 's' : ''}`)
			if (min > 0) partes.push(`${min} minuto${min > 1 ? 's' : ''}`)

			return partes.length > 0 ? partes.join(' e ') : '0 minuto'
		},
		atendimentoInfo() {
			const usuario = this.eventoEdit?.atendimento_data || null
			const usuarioInfo = {}

			if (usuario === null) return null

			if (usuario?.cliente_pf) {
				usuarioInfo.tipo = 'Cliente PF'
				usuarioInfo.nome = usuario.nome_cliente_pf
				usuarioInfo.data_atendimento = dayjs(usuario.data).format('DD/MM/YYYY')
			} else if (usuario?.fundacao) {
				usuarioInfo.tipo = 'Fundação'
				usuarioInfo.nome = usuario.nome_fundacao || usuario.sigla_fundacao
				usuarioInfo.data_atendimento = dayjs(usuario.data).format('DD/MM/YYYY')
			}

			return usuarioInfo
		},
	},
	watch: {
		'model.tipoAtendimento': {
			immediate: true,
			handler(novoValor) {
				if (novoValor?.value === 0) {
					this.model.dataPolitica = null
				}
			},
		},
		'model.isTemAtendimento': {
			immediate: true,
			handler(novoValor) {
				if (!novoValor) {
					this.model.tipoClienteAtendimento =
						TIPO_STATUS_ATENDIMENTO.SEM_ATENDIMENTO
					this.model.dataPolitica = null
					this.model.tipoAtendimento = null
				} else if (!this.isEditModo || !this.eventoEdit) {
					this.model.tipoClienteAtendimento = TIPO_STATUS_ATENDIMENTO.CLIENTE_PF
				}
			},
		},
		'model.usuarioSelecionado': {
			immediate: true,
			handler(novoUsuario) {
				if (this.isEditModo && this.eventoEdit) return

				this.optionsDataAtendimentoUsuario = []
				this.model.dataPolitica = null
				this.initEmailConvidados()
				if (novoUsuario) {
					if (
						novoUsuario.value.tipo.toLowerCase() ===
						TIPO_USUARIO.FUNDACAO.toLowerCase()
					) {
						this.setAtendimentoFundacao(novoUsuario.value.id)
					} else if (
						novoUsuario.value.tipo.toLowerCase() ===
						TIPO_USUARIO.CLIENTE_PF.toLowerCase()
					) {
						this.setAtendimentoClientepf(novoUsuario.value.id)
					}
				} else if (clienteSelecionado) {
					clienteSelecionado?.cliente?.contatos?.forEach((contato) => {
						this.removerConvidado(contato?.email)
					})

					clienteSelecionado = null
				}
			},
		},
		isOpenModal: {
			immediate: true,
			handler(valor) {
				if (valor) {
					this.initEmailConvidados()
				} else {
					this.resetarCamposModal()
				}
			},
		},
		eventoEdit: {
			immediate: true,
			async handler(novoEvento) {
				let isTemAtendimento = false
				let tipoClienteAtendimento = TIPO_STATUS_ATENDIMENTO.SEM_ATENDIMENTO

				if (novoEvento && this.isEditModo) {
					this.isReadOnly = this.isDoubleClick ? true : false
					this.labelBotaoPrincipal = this.isDoubleClick
						? 'Editar evento'
						: 'Salvar evento'

					if (novoEvento.atendimento_data) {
						isTemAtendimento = true
						const atendimento = novoEvento.atendimento_data

						if (atendimento.cliente_pf) {
							tipoClienteAtendimento = TIPO_STATUS_ATENDIMENTO.CLIENTE_PF
							this.clientesPf.push(atendimento)
							this.model.usuarioSelecionado = {
								label: atendimento.nome_cliente_pf || atendimento.nome,
								value: {
									id: atendimento.cliente_pf,
									tipo: TIPO_USUARIO.CLIENTE_PF,
								},
							}
						} else if (atendimento.fundacao) {
							tipoClienteAtendimento = TIPO_STATUS_ATENDIMENTO.FUNDACAO
							this.fundacoes.push(atendimento)
							this.model.usuarioSelecionado = {
								label:
									atendimento.nome_fundacao ||
									atendimento.sigla ||
									atendimento.nome,
								value: {
									id: atendimento.fundacao,
									tipo: TIPO_USUARIO.FUNDACAO,
								},
							}
						}

						this.optionsDataAtendimentoUsuario = [
							{
								label: formatDateObject(new Date(atendimento.data)),
								value: atendimento.id,
							},
						]

						this.model.dataPolitica =
							this.optionsDataAtendimentoUsuario[0] || null

						if (atendimento?.tipo) {
							this.model.tipoAtendimento =
								this.optionsTipoAtendimento.find(
									(opt) => opt.value === Number(atendimento.tipo)
								) || null
						}

						this.model.tipoClienteAtendimento = tipoClienteAtendimento
					}

					const convidadosEmails = (novoEvento.membrosEventos || []).map(
						(membro) => membro.email
					)
					const corpoEmail = this.extrairAntesSeparador(
						novoEvento.descricaoEvento
					)

					const lembreteOption =
						this.optionsLembreteAtendimento?.find(
							(opt) => opt.value === novoEvento.dataLembrete
						) || null

					const dataFormatada =
						GLOBAL.formatDateObject(new Date(novoEvento.dataEventoInicio)) ||
						null

					const startEvento = dayjs(novoEvento.dataEventoInicio)
						.tz('America/Sao_Paulo')
						.format('YYYY-MM-DDTHH:mm:ss')
					const endEvento = dayjs(novoEvento.dataEventoFim)
						.tz('America/Sao_Paulo')
						.format('YYYY-MM-DDTHH:mm:ss')

					this.model = {
						titulo: novoEvento.titulo || '',
						convidados: convidadosEmails.join(', '),
						dataEvento: dataFormatada,
						horaEventoInicio: this.formatarHoraParaInput(startEvento),
						horaEventoFim: this.formatarHoraParaInput(endEvento),
						localEvento: novoEvento.localEvento || '',
						descricaoEvento: corpoEmail || '',
						isDiaInteiro: !!novoEvento.isDiaInteiro,
						isTeams: !!novoEvento.isTeams,
						isTemAtendimento: isTemAtendimento,
						lembreteAtendimento: lembreteOption,
						tipoClienteAtendimento: tipoClienteAtendimento,
						usuarioSelecionado: this.model.usuarioSelecionado,
						tipoAtendimento: this.model.tipoAtendimento,
						dataPolitica: this.model.dataPolitica,
					}
					this.qeditor = corpoEmail || ''
					this.isReadOnly = this.isDoubleClick ? false : true
					this.labelBotaoPrincipal = this.isDoubleClick
						? 'Salvar evento'
						: 'Editar evento'
					editorEventoQuill.root.innerHTML = this.model.descricaoEvento
				} else {
					this.resetarCamposModal()
					this.isReadOnly = false
					this.labelBotaoPrincipal = 'Salvar evento'
				}
				this.initEmailConvidados()
			},
		},
		isEditModo: {
			immediate: true,
			handler(valor) {
				if (valor) {
					this.isReadOnly = this.isDoubleClick ? true : false
					this.labelBotaoPrincipal = this.isDoubleClick
						? 'Editar evento'
						: 'Salvar evento'
				} else {
					this.isReadOnly = false
					this.labelBotaoPrincipal = 'Salvar evento'
				}
			},
		},
		isReadOnly: {
			immediate: true,
			handler(valor) {
				if (editorEventoQuill) {
					editorEventoQuill.enable(!valor)
				}
			},
		},
		isDoubleClick: {
			immediate: true,
			handler(valor) {
				if (valor && this.isEditModo) {
					this.isReadOnly = false
					this.labelBotaoPrincipal = 'Salvar evento'
				}
			},
		},
		'model.tipoClienteAtendimento': {
			immediate: true,
			async handler(novoTipo) {
				if (this.isEditModo && this.eventoEdit) return

				await this.buscarUsuarios(novoTipo)

				if (novoTipo === 'cliente_pf') {
					this.optionsUsuarioSelect = this.clientesPf.map((cliente) => ({
						label: cliente.nome,
						value: { id: cliente.id, tipo: TIPO_USUARIO.CLIENTE_PF },
					}))
				} else if (novoTipo === 'fundacao') {
					this.optionsUsuarioSelect = this.fundacoes.map((fundacao) => ({
						label: fundacao.sigla,
						value: { id: fundacao.id, tipo: TIPO_USUARIO.FUNDACAO },
					}))
				} else {
					this.optionsUsuarioSelect = []
				}

				this.model.usuarioSelecionado = null

				this.removerConvidado()
			},
		},
	},

	methods: {
		ruleUsuarioSelecionado(val) {
			if (this.model.isTemAtendimento) {
				return !!val || 'Obrigatório'
			}
			return true
		},
		ruleDiaIneiroSelecionado(val) {
			if (!this.model.isDiaInteiro) {
				return !!val || 'Obrigatório'
			}
			return true
		},
		acumularClienteSelecionado(cliente) {
			let clienteData = null

			if (!cliente) return

			if (
				this.model.tipoClienteAtendimento === TIPO_STATUS_ATENDIMENTO.CLIENTE_PF
			) {
				clienteData = cliente.clientes[0]
				clienteData.tipoCliente = TIPO_USUARIO.CLIENTE_PF
			} else if (
				this.model.tipoClienteAtendimento === TIPO_STATUS_ATENDIMENTO.FUNDACAO
			) {
				clienteData = cliente.fundacoes[0]
				clienteData.tipoCliente = TIPO_USUARIO.FUNDACAO
			}
			return { cliente: { ...clienteData, contatos: cliente.contatos } }
		},
		removerConvidado(email) {
			if (!email) return
			let convidados = this.convertConvidadosStringToArray(
				this.model.convidados
			)
			convidados = convidados.filter((item) => item !== email.trim())
			this.model.convidados = convidados.join(', ')
		},
		adicionarConvidado(email) {
			if (!email) return
			let convidados = this.convertConvidadosStringToArray(
				this.model.convidados
			)
			if (!convidados.includes(email.trim())) {
				convidados.push(email.trim())
				this.model.convidados = convidados.join(', ')
			}
		},
		initEmailConvidados() {
			if (!this.isEditModo) {
				this.model.convidados = EMAILS_CLIENTES_FIXOS.join(', ')
			}
		},
		formatarDataEvento() {
			let val = this.model.dataEvento
			let dia, mes, ano

			if (/^\d{4}-\d{2}-\d{2}$/.test(val)) {
				;[ano, mes, dia] = val.split('-')
			} else if (/^\d{2}\/\d{2}\/\d{4}$/.test(val)) {
				;[dia, mes, ano] = val.split('/')
			} else if (/^\d{2} \w{3}\. \d{4}$/.test(val)) {
				return
			} else {
				return
			}

			const meses = [
				'jan',
				'fev',
				'mar',
				'abr',
				'mai',
				'jun',
				'jul',
				'ago',
				'set',
				'out',
				'nov',
				'dez',
			]
			const mesFormatado = meses[parseInt(mes, 10) - 1]
			if (dia && mesFormatado && ano) {
				this.model.dataEvento = `${parseInt(dia, 10)} ${mesFormatado}. ${ano}`
			}
		},
		formatarHoraInput(e) {
			let valor = e.target.value.trim()

			if (/^:\d{1,2}$/.test(valor)) {
				const min = valor.replace(':', '').padStart(2, '0')
				valor = `00:${min}`
			} else {
				valor = valor.replace(/\D/g, '')

				if (valor.length === 0) {
					e.target.value = ''
					this.model.horaEvento = ''
					return ''
				}

				if (valor.length === 1) {
					valor = `0${valor}:00`
				} else if (valor.length === 2) {
					valor = `${valor}:00`
				} else if (valor.length === 3) {
					valor = `${valor.slice(0, 2)}:${valor.slice(2)}0`
				} else if (valor.length >= 4) {
					valor = `${valor.slice(0, 2)}:${valor.slice(2, 4)}`
				}
			}

			return valor
		},
		formatarDataParaInput(dataIso) {
			if (!dataIso) return ''
			if (typeof dataIso === 'string') {
				const [date] = dataIso.split('T')
				if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
					return date
				}
			}
			return ''
		},
		formatarHoraParaInput(dataIso) {
			if (!dataIso) return ''
			if (typeof dataIso === 'string') {
				const partes = dataIso.split('T')
				if (partes.length > 1) {
					const hora = partes[1].slice(0, 5)
					if (/^\d{2}:\d{2}$/.test(hora)) {
						return hora
					}
				} else if (/^\d{2}:\d{2}$/.test(dataIso)) {
					return dataIso
				}
			}
			return ''
		},
		formataDataIsoLocal(dateObj) {
			const dataObjLocal = dayjs(dateObj)
			const stringIsoLocal = dataObjLocal.format('YYYY-MM-DDTHH:mm:ss')

			return stringIsoLocal
		},
		formatarDataEventoDiaInteiro(dateObj) {
			if (!dayjs(dateObj).isValid()) return ''
			return dayjs(dateObj).format('YYYY-MM-DDTHH:mm:ss')
		},
		extrairAntesSeparador(texto) {
			const separador =
				'\r\n\r\n\r\n________________________________________________________________________________\r'
			const indice = texto.indexOf(separador)
			if (indice === -1) return texto
			return texto.substring(0, indice)
		},
		createEditorEventoQuill() {
			const SizeStyle = Quill.import('attributors/style/size')
			const AlignStyle = Quill.import('attributors/style/align')

			SizeStyle.whitelist = null

			Quill.register(AlignStyle, true)
			Quill.register(SizeStyle, true)

			editorEventoQuill = new Quill('#texto-descricao-evento', {
				theme: 'snow',
				formats: [
					'bold',
					'italic',
					'underline',
					'strike',
					'size',
					'color',
					'list',
					'bullet',
					'check',
					'background',
					'align',
					'header',
					'clean',
				],
				modules: {
					toolbar: [
						[{ header: [1, 2, false] }],
						[{ size: ['small', false, 'large', 'huge'] }],
						['bold', 'italic', 'underline'],
						[{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
						['clean'],
					],
				},
			})

			editorEventoQuill.on('text-change', () => {
				this.qeditor = editorEventoQuill.root.innerHTML
				this.model.descricaoEvento = editorEventoQuill.root.innerHTML
			})

			editorEventoQuill.clipboard.addMatcher(
				Node.ELEMENT_NODE,
				(node, delta) => {
					return delta
				}
			)

			if (this.qeditor) {
				editorEventoQuill.root.innerHTML = this.qeditor
			}
		},
		converterDataParaIso(dataFormatada) {
			if (!/^\d{2}\/\d{2}\/\d{4}$/.test(dataFormatada)) return ''
			const [dia, mes, ano] = dataFormatada.split('/')
			return `${ano}-${mes}-${dia}`
		},
		convertConvidadosStringToArray(convidadosString) {
			if (!convidadosString) return []
			return convidadosString
				.split(',')
				.map((email) => email.trim())
				.filter((email) => email)
		},
		isDataFormatoAbreviado(data) {
			return /^\d{1,2} \w{3}\.? \d{4}$/.test(data)
		},
		closeModal() {
			this.$emit('click:close-modal')
		},
		atualizarQuillComDescricao() {
			if (this.isEditModo && editorEventoQuill && this.model.descricaoEvento) {
				editorEventoQuill.root.innerHTML = this.model.descricaoEvento
			}
		},
		criarEventoCalendario() {
			const dataIso = this.converterDataParaIso(this.model.dataEvento)
			let horaInicio = this.model.horaEventoInicio
			let horaFim = this.model.horaEventoFim
			let dataEventoFim = dataIso

			if (this.model.isDiaInteiro) {
				horaInicio = '00:00:00'
				const dataObj = new Date(dataIso)
				dataObj.setDate(dataObj.getDate() + 1)
				dataEventoFim = dataObj.toISOString().slice(0, 10)
				horaFim = '00:00:00'
			} else {
				horaInicio = horaInicio ? `${horaInicio}:00` : ''
				horaFim = horaFim ? `${horaFim}:00` : ''
			}
		},
		criarDatasEvento() {
			const { dataEvento, horaEventoInicio, horaEventoFim, isDiaInteiro } =
				this.model

			let dataIso = this.converterDataParaIso(dataEvento)

			let dataInicioEvento, dataFimEvento

			if (isDiaInteiro) {
				dataInicioEvento = new Date(`${dataIso}T00:00:00`)
				dataFimEvento = new Date(dataInicioEvento)
				dataFimEvento.setDate(dataFimEvento.getDate() + 1)
				dataFimEvento.setHours(0, 0, 0, 0)
			} else {
				const horaIni = horaEventoInicio ? `${horaEventoInicio}` : '00:00:00'
				const horaFim = horaEventoFim ? `${horaEventoFim}` : '00:00:00'

				dataInicioEvento = new Date(`${dataIso}T${horaIni}`)
				dataFimEvento = new Date(`${dataIso}T${horaFim}`)
			}

			if (isNaN(dataInicioEvento.getTime()) || isNaN(dataFimEvento.getTime())) {
				return { dataInicioEvento: null, dataFimEvento: null }
			}

			return { dataInicioEvento, dataFimEvento }
		},
		criarPayloadEvento() {
			const { dataInicioEvento, dataFimEvento } = this.criarDatasEvento()

			const isDiaInteiro = this.model.isDiaInteiro

			const usuarioSelecionado = this.model.usuarioSelecionado
				? this.model.usuarioSelecionado.value
				: null

			const tipoAtendimento =
				this.model.tipoAtendimento?.value != null
					? this.model.tipoAtendimento.value
					: null

			const dataPolitica =
				this.model.dataPolitica?.value instanceof Date
					? this.formataDataIsoLocal(this.model.dataPolitica.value)
					: this.model.dataPolitica?.value

			const lembreteAtendimento =
				this.model.lembreteAtendimento?.value != null
					? this.model.lembreteAtendimento.value
					: null

			const payload = {
				...this.model,
				convidados: this.convertConvidadosStringToArray(this.model.convidados),
				dataEventoInicio: isDiaInteiro
					? this.formatarDataEventoDiaInteiro(dataInicioEvento)
					: this.formataDataIsoLocal(dataInicioEvento),
				dataEventoFim: isDiaInteiro
					? this.formatarDataEventoDiaInteiro(dataFimEvento)
					: this.formataDataIsoLocal(dataFimEvento),
				usuarioSelecionado,
				tipoAtendimento,
				dataPolitica,
				lembreteAtendimento,
			}
			return payload
		},
		criarEventoCalendario() {
			this.$emit('click:criar-evento', this.criarPayloadEvento())
		},
		atualizarEventoCalendario() {
			const payload = this.criarPayloadEvento()
			payload.id = this.eventoEdit?.idEventoOriginal
			this.$emit('click:atualiza-evento', payload)
		},
		sincronizarHoraFimComInicio() {
			if (this.model.isDiaInteiro) return

			const inicio = this.model.horaEventoInicio
			const fim = this.model.horaEventoFim
			if (inicio && fim) {
				const hoje = dayjs().format('YYYY-MM-DD')
				const inicioObj = dayjs(`${hoje}T${inicio}`)
				const fimObj = dayjs(`${hoje}T${fim}`)
				if (inicioObj.isAfter(fimObj)) {
					this.model.horaEventoFim = inicio
				}
			}
		},
		onSubmit(e) {
			e.preventDefault()

			this.$refs.form.validate().then((success) => {
				if (success) {
					e.preventDefault()
					if (this.isEditModo && this.isReadOnly) {
						this.isReadOnly = false
						this.labelBotaoPrincipal = 'Salvar evento'
					} else if (this.isEditModo && !this.isReadOnly) {
						this.atualizarEventoCalendario()
					} else {
						this.criarEventoCalendario()
					}
				} else {
					showToastify('❌ Por favor, preencha os campos obrigatórios.')
				}
			})
		},
		onBlurHoraInicio(e) {
			const valor = this.formatarHoraInput(e)
			e.target.value = valor
			this.model.horaEventoInicio = valor
			this.sincronizarHoraFimComInicio()
		},
		onBlurHoraFim(e) {
			const valor = this.formatarHoraInput(e)
			e.target.value = valor
			this.model.horaEventoFim = valor
			this.sincronizarHoraFimComInicio()
		},
		onBlurHora(e) {
			const valor = this.formatarHoraInput(e)
			this.model.horaEventoInicio = valor
			e.target.value = valor
		},
		onInputHora(e) {
			let valor = e.target.value.replace(/[^\d:]/g, '')

			if (/^:\d{1,2}$/.test(valor)) {
				valor = '00:' + valor.slice(1).padStart(2, '0')
			} else if (/^\d{1,2}$/.test(valor)) {
				if (valor.length === 2) {
					valor = valor + ':00'
				}
			} else if (/^\d{3,4}$/.test(valor.replace(':', ''))) {
				valor = valor.replace(':', '')
				valor = valor.padStart(4, '0')
				valor = valor.slice(0, 2) + ':' + valor.slice(2, 4)
			} else if (/^\d{2}:\d{2}$/.test(valor)) {
			} else if (/^\d{1}:\d{2}$/.test(valor)) {
				valor = '0' + valor
			} else if (/^\d{2}:\d{1}$/.test(valor)) {
				valor = valor.slice(0, 3) + '0'
			}

			if (valor.length > 5) valor = valor.slice(0, 5)

			e.target.value = valor
			return valor
		},
		resetarCamposModal() {
			this.model = {
				titulo: null,
				convidados: null,
				dataEvento: null,
				horaEventoInicio: null,
				horaEventoFim: null,
				localEvento: null,
				descricaoEvento: null,
				isDiaInteiro: false,
				isTeams: false,
				isTemAtendimento: false,
				tipoClienteAtendimento: TIPO_STATUS_ATENDIMENTO.SEM_ATENDIMENTO,
				usuarioSelecionado: null,
				tipoAtendimento: null,
				dataPolitica: null,
				lembreteAtendimento: null,
			}
			this.qeditor = null
			if (editorEventoQuill) {
				editorEventoQuill.root.innerHTML = ''
			}
			opcaoAnteriorUsuario = null
			clienteSelecionado = null

			this.clientesPf = []
			this.fundacoes = []
			this.optionsUsuarioSelect = []
			this.optionsDataAtendimentoUsuario = []

			if (this.$refs.form) {
				this.$refs.form.resetValidation()
			}
		},
		async buscarUsuarios(
			tipoClientePf = TIPO_STATUS_ATENDIMENTO.SEM_ATENDIMENTO,
			search = ''
		) {
			this.loadingUsuarios = true
			const params = {
				page: 1,
				search: search,
			}

			try {
				if (
					this.model.tipoClienteAtendimento ===
					TIPO_STATUS_ATENDIMENTO.CLIENTE_PF
				) {
					const clientesResp = await getClientesPf(params)
					this.clientesPf = clientesResp?.results || []
					this.fundacoes = []
				} else if (
					this.model.tipoClienteAtendimento === TIPO_STATUS_ATENDIMENTO.FUNDACAO
				) {
					const { getFundacoes } = fundacaoService()
					const fundacoesResp = await getFundacoes(params)
					this.fundacoes = fundacoesResp?.results || []
					this.clientesPf = []
				} else {
					this.clientesPf = []
					this.fundacoes = []
				}
			} catch (e) {
				console.error('Erro ao buscar usuários:', e)
			} finally {
				this.loadingUsuarios = false
			}
		},
		async filterOptions(val, update) {
			if (!val) {
				update(() => {})
				return
			}

			this.loadingUsuarios = true
			try {
				await this.buscarUsuarios(this.model.tipoClienteAtendimento, val)
				// Atualize as opções do select aqui:
				if (this.model.tipoClienteAtendimento === 'cliente_pf') {
					this.optionsUsuarioSelect = this.clientesPf.map((cliente) => ({
						label: cliente.nome,
						value: { id: cliente.id, tipo: 'PF' },
					}))
				} else if (this.model.tipoClienteAtendimento === 'fundacao') {
					this.optionsUsuarioSelect = this.fundacoes.map((fundacao) => ({
						label: fundacao.sigla,
						value: { id: fundacao.id, tipo: 'FUNDACAO' },
					}))
				} else {
					this.optionsUsuarioSelect = []
				}
				opcaoAnteriorUsuario = val
				update(() => {})
			} catch (e) {
				console.error('Erro ao filtrar usuários:', e)
				update(() => {})
			} finally {
				this.loadingUsuarios = false
			}
		},
		async onClearSelect() {
			await this.buscarUsuarios(this.model.tipoClienteAtendimento, '')
			opcaoAnteriorUsuario = null

			if (this.model.tipoClienteAtendimento === 'cliente_pf') {
				this.optionsUsuarioSelect = this.clientesPf.map((cliente) => ({
					label: cliente.nome,
					value: { id: cliente.id, tipo: 'PF' },
				}))
			} else if (this.model.tipoClienteAtendimento === 'fundacao') {
				this.optionsUsuarioSelect = this.fundacoes.map((fundacao) => ({
					label: fundacao.sigla,
					value: { id: fundacao.id, tipo: 'FUNDACAO' },
				}))
			} else {
				this.optionsUsuarioSelect = []
			}
		},
		async setAtendimentoClientepf(clienteId) {
			if (!clienteId) return
			this.loadingDataAtendimento = true
			try {
				const params = {
					cliente_pf: clienteId,
				}
				const responseAtendimento =
					(await getInfoAtendimentoCliente('', params)) || []

				const atendimentosValidos =
					responseAtendimento?.atendimentos?.filter(
						(item) =>
							item &&
							item.status_atendimento?.toLowerCase() === 'aguardando' &&
							!item.concluido
					) || []

				clienteSelecionado =
					this.acumularClienteSelecionado(responseAtendimento)

				this.optionsDataAtendimentoUsuario = atendimentosValidos?.map(
					(item) => ({
						label: formatDateObject(new Date(item.data)),
						value: item.id,
					})
				)

				clienteSelecionado.cliente.contatos
					.filter((contato) => contato?.principal)
					.forEach((contato) => {
						this.adicionarConvidado(contato?.email)
					})
			} catch (error) {
				console.error('Erro ao buscar informações do atendimento:', error)
			} finally {
				this.loadingDataAtendimento = false
			}
		},
		async setAtendimentoFundacao(fundacaoId) {
			if (!fundacaoId) return
			this.loadingDataAtendimento = true
			try {
				const params = {
					fundacao: fundacaoId,
				}
				const responseFundacao = await getInformacoesFundacao('', params)
				const atendimentosValidos =
					responseFundacao?.atendimentos?.filter(
						(item) =>
							item &&
							item.status_atendimento?.toLowerCase() === 'aguardando' &&
							!item.concluido
					) || []

				clienteSelecionado = this.acumularClienteSelecionado(responseFundacao)

				this.optionsDataAtendimentoUsuario = atendimentosValidos?.map(
					(item) => ({
						label: formatDateObject(new Date(item.data)),
						value: item.id,
					})
				)

				clienteSelecionado.cliente.contatos
					.filter((contato) => contato?.principal)
					.forEach((contato) => {
						this.adicionarConvidado(contato?.email)
					})
			} catch (error) {
				console.error('Erro ao buscar informações da fundação:', error)
			} finally {
				this.loadingDataAtendimento = false
			}
		},
	},
	async mounted() {
		this.createEditorEventoQuill()
		await this.buscarUsuarios()
	},

	template: `
        <section class="modal--content rounded-md flex-1 !w-full !h-max overflow-[initial]"
        data-id="modal_novo_evento_calendario"
        id="modal_novo_evento_calendario">
            <header class="flex justify-between items-center bg-primary w-full h-[4.5rem] p-24">
                <h1 class="text-title-2 text-white">{{ tituloModal }}</h1>

                <q-btn icon="close" class="text-white" rounded @click="closeModal"></q-btn>
            </header>
            <q-form ref="form" class="w-full h-full !max-h-[50rem] overflow-auto">
                <div class="grid grid-cols-12 gap-24 py-24">
                    <div class="col-span-full flex justify-between items-center px-24 gap-24">
						<q-icon v-if="false" name="title" size="md" class="text-neutral-70"/>

						<q-icon size="24px" class="text-neutral-70">
							<svg>
								<use xlink:href="#icon_titulo_texto"></use>
							</svg>
						</q-icon>

                        <q-input
                            v-model="model.titulo"
							:disable="isDisableFieldsEditFormulario"
                            name="titulo"
							lazy-rules
							:reactive-rules="false"
                            :rules="[val => !!val || 'Obrigatório']"
                            id="input-titulo"
                            label="Adicione um título"
                            label-color="neutral-70"
                            type="text"
							autocomplete="off"
							:error-message-class="'text-negative'"
                            class="!flex-1"
                            />
                    </div>


					<div  class="col-span-full">
						<p class="!ml-[5.3rem] text-headline-2 text-neutral-70 w-max">Atendimento</p>
					</div>

					<div  class="col-span-full flex items-start px-24 gap-16">
						<q-icon size="md" class="text-neutral-70 mr-12">
							<svg>
								<use xlink:href="#icon_chat_mensagem"></use>
							</svg>
						</q-icon>
							
						<div class="!flex !items-center !gap-48 classe-principal">
							<div>
								<label class="text-neutral-70 text-paragraph-2">
									Essa reunião precisa gerar um atendimento?
								</label>

								<div class="flex items-center gap-24 mt-16">
									<q-radio v-model="model.isTemAtendimento" :disable="isEditModo" :val="true" label="Sim" class="text-neutral-80 text-headline-2"/>
									<q-radio v-model="model.isTemAtendimento" :disable="isEditModo" :val="false" label="Não" class="text-neutral-80 text-headline-2"/>
								</div>
							</div>

							<div v-show="model.isTemAtendimento">
								<label class="text-neutral-70 text-paragraph-2">
									Tipo de Cliente
								</label>

								<div class="flex items-center gap-24 mt-16">
									<q-radio v-model="model.tipoClienteAtendimento" :disable="isEditModo" :val="'cliente_pf'" label="Cliente PF" class="text-neutral-80 text-headline-2"/>
									<q-radio v-model="model.tipoClienteAtendimento" :disable="isEditModo" :val="'fundacao'" label="Fundação" class="text-neutral-80 text-headline-2"/>
								</div>
							</div>
						</div>
					</div>

					<div v-show="model.isTemAtendimento" class="col-span-full flex justify-between items-center px-24 gap-24">
						<q-icon size="md" class="text-neutral-70">
							<svg>
								<use xlink:href="#icon_add_usuario"></use>
							</svg>
						</q-icon>

						<q-select 
							v-model="model.usuarioSelecionado"
							use-input
    						input-debounce="300" 
							clearable  
							label="Selecione o(s) Cliente(s)" 
							label-color="neutral-70" 
							:disable="isEditModo"
							:options="optionsUsuarioSelect"
							:loading="loadingUsuarios"
							autocomplete="off"
							lazy-rules
							:rules="[ruleUsuarioSelecionado]"
							@filter="filterOptions"
							@clear="onClearSelect"
							class="w-full"/>
					</div>

					<div v-if="model.isTemAtendimento" class="col-span-full flex justify-between items-center px-24 gap-24">
						<q-icon size="md" class="text-neutral-70">
							<svg class="w-full h-full">
								<use xlink:href="#icon_suporte_usuario"></use>
							</svg>
						</q-icon>

						<div class="flex-1 flex justify-between items-center gap-24">
							<q-select 
								v-model="model.tipoAtendimento" 
								label="Tipo de atendimento"  
								label-color="neutral-70" 
								:options="optionsTipoAtendimento"
								:disable="isEditModo"
								lazy-rules
								:rules="[ruleUsuarioSelecionado]"
								autocomplete="off" 
								class="flex-1"/>

							<q-select 
								v-if="model.tipoAtendimento && model?.tipoAtendimento?.value === 0"
								v-model="model.dataPolitica"		 
								label="Data da política"  
								label-color="neutral-70" 
								:loading="loadingDataAtendimento"
								:options="optionsDataAtendimentoUsuario"
								:disable="isEditModo"
								lazy-rules
								:rules="[rule=>true]"
								autocomplete="off"
								class="flex-1"/>
						</div>
					</div>
					
					<div class="col-span-full">
						<p class="!ml-[5.3rem] text-headline-2 text-neutral-70 w-max">Evento</p>
					</div>

                    <div class="col-span-full flex justify-between items-start px-24 gap-24">
						<q-icon size="md" class="text-neutral-70 mt-14">
							<svg>
								<use xlink:href="#icon_email_calendario"></use>
							</svg>
						</q-icon>

                        <div  class="!flex-1 flex flex-col gap-8">
                            <q-input 
								v-model="model.convidados"
								:disable="isDisableFieldsEditFormulario"
                                name="convidados" 
                                id="input-convidados"
                                class="!w-full"
                                label="Adicionar convidados"
                                label-color="neutral-70"
                                type="text" 
								autocomplete="off"
								/>
                            <label class="text-neutral-70 text-paragraph-3">Adicione vários convidados separando os e-mails com vírgula (,).</label>
                        </div>  
                    </div>

                    <div class="col-span-full flex justify-between items-center px-24 gap-24">
						<q-icon size="md" class="text-neutral-70">
							<svg>
								<use xlink:href="#icon_relogio"></use>
							</svg>
						</q-icon>	
					

                        <div class="flex-1 grid grid-cols-12 items-center gap-24">
							<q-input
								v-model="model.dataEvento"  
								:disable="isDisableFieldsEditFormulario"
								label="Data"
								label-color="neutral-70"
								placeholder="dd/mm/aaaa"
								class="!col-span-3"
								autocomplete="off"
								mask="##/##/####"
								lazy-rules
								:rules="[val => !!val || 'Obrigatório']">
								<template v-slot:append>
									<q-icon name="event" class="cursor-pointer">
									<q-popup-proxy cover transition-show="scale" transition-hide="scale">
										<q-date v-model="model.dataEvento" mask="DD/MM/YYYY">
										<div class="row items-center justify-end">
											<q-btn v-close-popup label="Close" color="primary" flat />
										</div>
										</q-date>
									</q-popup-proxy>
									</q-icon>
								</template>
							</q-input>

                            <div  class="!col-span-2">
                                <q-input
									v-if="!model.isDiaInteiro"
                                    v-model="model.horaEventoInicio"
									:disable="isDisableFieldsEditFormulario"
                                    label="Início"
                                    label-color="neutral-70"
                                    name="horaEventoInicio"
                                    id="input-horaEventoInicio"  
                                    type="text"
                                    mask="##:##"
									autocomplete="off"
									lazy-rules
									:rules="[ruleDiaIneiroSelecionado]"
                                    class="w-full h-full"	
                                    @blur="onBlurHoraInicio"
                                    />
                                </div>
                          
                            <div class="!col-span-1">
								<label v-if="!model.isDiaInteiro" class="text-center text-neutral-70">até</label>
							</div>
                            
                            <div class="!col-span-2">
                                    <q-input
										v-if="!model.isDiaInteiro"
                                        v-model="model.horaEventoFim"
										:disable="isDisableFieldsEditFormulario"
                                        label="Fim"
                                        label-color="neutral-70"
                                        name="horaEventoFim"
										lazy-rules
                                        :rules="[ruleDiaIneiroSelecionado]"
                                        id="input-horaEventoFim"  
                                        type="text"
                                        mask="##:##"
										autocomplete="off"
                                        class="w-full h-full"										
                                        @blur="onBlurHoraFim"
                                    />
                                </div>

                            <span class="col-span-1"></span>

                            <div class="!col-span-3">
                                <q-checkbox 
									v-model="model.isDiaInteiro" 
									:disable="isDisableFieldsEditFormulario"
									size="1.25rem" 
									label="Dia inteiro"
									autocomplete="off"
									class="text-neutral-70"></q-checkbox>
                            </div>
                        </div>
                    </div>

					<div class="col-span-full flex justify-between items-center px-24 gap-24">
						<q-icon size="md" class="text-neutral-70">
							<svg>
								<use xlink:href="#icon_relogio_alarme"></use>
							</svg>
						</q-icon>	

						<q-select 
							v-model="model.lembreteAtendimento"
							:options="optionsLembreteAtendimento"
							:disable="isDisableFieldsEditFormulario"
							clearable
							autocomplete="off"
							label="Lembrete"  
							label-color="neutral-70"
							popup-content-class="select-menu"
							transition-duration="150"
							dropdown-icon="expand_more" 
							class="flex-1 custom-select-style"/>
					</div>

                    <div  class="col-span-full flex justify-between items-center px-24 gap-24">
						<q-icon size="md" class="text-neutral-70">
							<svg>
								<use xlink:href="#icon_localizacao"></use>
							</svg>
						</q-icon>	

                        <q-input
                            v-model="model.localEvento"
							:disable="isDisableFieldsEditFormulario"
                            name="localEvento"
                            
                            id="input-localEvento"
                            class="flex-1 h-48"
                            label="Adicione uma sala ou local"
                            label-color="neutral-70"
                            type="text"
							autocomplete="off"
							/>

                        <div class="flex-1 flex items-center gap-16">
                            <q-checkbox 
								v-model="model.isTeams" 
								size="1.25rem" 
								label="Reunião do Teams"
								:disable="isEditModo"
								class="text-neutral-70"></q-checkbox>
							<q-icon v-if="false" name="groups" size="md" class="text-neutral-70"/>

                            <svg class="w-20 h-20">
								<use xlink:href="#icon_atendimento_rapido_email"></use>
							</svg>
                        </div>
                    </div>

                    <div class="col-span-full flex justify-between items-start px-24 gap-24">
					  <q-icon name="format_align_left" size="md" class="text-neutral-70"/>


                      <div class="flex-1">
                        <div id="texto-descricao-evento"></div>
                      </div>
                    </div>

					<div
						class="
							col-span-full 
							flex 
							justify-end 
							items-start 
							px-24 
							gap-24">
						<q-btn
							:disabled="loading"
							class="btn h-48 secondary "
							@click="closeModal">
								Cancelar
						</q-btn>

                       <q-btn             
                            :loading="loading"
							@click="onSubmit"
                            class="btn h-48 primary ">
                                {{ labelBotaoPrincipal }}
                        </q-btn>
                    </div>
                    
                </div>
            </q-form>
        </section>
    `,
}
